import { render, staticRenderFns } from "./permission-set.vue?vue&type=template&id=4f984db2&scoped=true&"
import script from "./permission-set.vue?vue&type=script&lang=js&"
export * from "./permission-set.vue?vue&type=script&lang=js&"
import style0 from "./permission-set.vue?vue&type=style&index=0&id=4f984db2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f984db2",
  null
  
)

export default component.exports